export const API_URL = `https://forkify-api.jonas.io/api/v2/recipes/`;
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = '89532a87-1b74-4867-828e-6c21d55c5a1f';
export const MODAL_CLOSE_SEC = 2.5;